// extracted by mini-css-extract-plugin
export default {"button":"Editor_button__V79tl","input":"Editor_input__0vHnZ"};